export default __webpack_public_path__ + "static/media/stock.5eba755a.jpg";